/** Qawaem localStorage / secureStorage key names (Saudi ERP). */

export const QAWAEM_SETTINGS_KEY = 'qawaem-settings';
export const QAWAEM_USER_KEY = 'qawaem_user';
export const QAWAEM_ADMIN_USER_KEY = 'qawaem_admin_user';
export const QAWAEM_TOKEN_KEY = 'qawaem_token';
export const QAWAEM_LICENSE_KEY = 'qawaem_license';
export const QAWAEM_LICENSE_KEY_SECURE = 'qawaem_license_key';
export const QAWAEM_SETUP_COMPLETED_KEY = 'qawaem_setup_completed';
export const QAWAEM_AUDIT_LOGS_KEY = 'qawaem_audit_logs';
export const QAWAEM_USERS_PERMISSIONS_KEY = 'qawaem_users_permissions';
export const QAWAEM_CUSTOM_ROLES_KEY = 'qawaem_custom_roles';
export const QAWAEM_ADMIN_EMAIL_HINT_KEY = 'qawaem_admin_email_hint';
export const QAWAEM_PRODUCT_KEY_VALIDATED_KEY = 'qawaem_product_key_validated';
export const QAWAEM_LICENSE_TYPE_KEY = 'qawaem_license_type';
export const QAWAEM_SETTINGS_LEGACY_KEY = 'qawaem_settings';
export const QAWAEM_CLIENTS_KEY = 'qawaem_clients';
export const QAWAEM_PRODUCTS_KEY = 'qawaem_products';
export const QAWAEM_PURCHASES_KEY = 'qawaem-purchases';
export const QAWAEM_SALES_KEY = 'qawaem-sales';
export const QAWAEM_STOCK_MOVEMENTS_KEY = 'qawaem-stock-movements';

/** One-time copy from pre-Qawaem `invoit_*` keys (Origin ERP). */
const LEGACY_INVOIT_TO_QAWAEM = [
  ['invoit-settings', QAWAEM_SETTINGS_KEY],
  ['invoit_user', QAWAEM_USER_KEY],
  ['invoit_admin_user', QAWAEM_ADMIN_USER_KEY],
  ['invoit_token', QAWAEM_TOKEN_KEY],
  ['invoit_license', QAWAEM_LICENSE_KEY],
  ['invoit_license_key', QAWAEM_LICENSE_KEY_SECURE],
  ['invoit_setup_completed', QAWAEM_SETUP_COMPLETED_KEY],
  ['invoit_audit_logs', QAWAEM_AUDIT_LOGS_KEY],
  ['invoit_users_permissions', QAWAEM_USERS_PERMISSIONS_KEY],
  ['invoit_custom_roles', QAWAEM_CUSTOM_ROLES_KEY],
  ['invoit_admin_email_hint', QAWAEM_ADMIN_EMAIL_HINT_KEY],
  ['invoit_product_key_validated', QAWAEM_PRODUCT_KEY_VALIDATED_KEY],
  ['invoit_license_type', QAWAEM_LICENSE_TYPE_KEY],
  ['invoit_settings', QAWAEM_SETTINGS_LEGACY_KEY],
  ['invoit_clients', QAWAEM_CLIENTS_KEY],
  ['invoit_products', QAWAEM_PRODUCTS_KEY],
  ['invoit-purchases', QAWAEM_PURCHASES_KEY],
  ['invoit-sales', QAWAEM_SALES_KEY],
  ['invoit-stock-movements', QAWAEM_STOCK_MOVEMENTS_KEY],
  ['invoit_default_credentials', 'qawaem_default_credentials'],
  ['invoit_schema_updated', 'qawaem_schema_updated'],
  ['invoit_profile_prefs', 'qawaem_profile_prefs'],
  ['invoit_login_history', 'qawaem_login_history'],
  ['invoitStampPosition', 'qawaemStampPosition'],
  ['invoitSignaturePosition', 'qawaemSignaturePosition'],
  ['invoitStampSize', 'qawaemStampSize'],
  ['invoitSignatureSize', 'qawaemSignatureSize'],
];

export function migrateLegacyInvoitStorageKeys() {
  if (typeof localStorage === 'undefined') return;
  for (const [oldKey, newKey] of LEGACY_INVOIT_TO_QAWAEM) {
    try {
      const value = localStorage.getItem(oldKey);
      if (value !== null && localStorage.getItem(newKey) === null) {
        localStorage.setItem(newKey, value);
      }
    } catch {
      /* ignore quota / private mode */
    }
  }
}
